// extracted by mini-css-extract-plugin
export default {"wrapper":"kE-z","viewport":"lE-z","container":"mE-z","slide":"nE-z"};